import { m } from 'motion/react';
// @mui
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hook';
// components
import { varHover } from 'src/components/animate';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
// Utils
import { PAYMENT_STRIPE_STATUS } from 'src/constant';
// context
import { useAuthContext } from 'src/auth/hooks';

// ----------------------------------------------------------------------

export default function AccountPopover() {
  // Hooks
  const { userSession } = useAuthContext();
  const router = useRouter();
  const popover = usePopover();

  const OPTIONS = [
    {
      label: 'Home',
      linkTo: '/dashboard',
    },
    {
      label: 'Profile',
      linkTo: paths.dashboard.users.edit(userSession.id),
    },
    {
      label: 'Support',
      linkTo: 'https://calendly.com/salesrushai/sales-rush-support',
    },
  ];

  const handleLogout = () => {
    popover.onClose();
    router.replace(paths.auth.login);
  };

  const handleClickItem = (path) => {
    popover.onClose();
    if (path.includes('https')) {
      window.open(path, '_blank')
    } else {
      router.push(path);
    }
  };

  return (
    <>
      <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        onClick={popover.onOpen}
        sx={{
          width: 40,
          height: 40,
          background: (theme) => alpha(theme.palette.grey[500], 0.08),
          ...(popover.open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Avatar
          src={userSession.avatar_url}
          alt='Avatar'
          sx={{
            width: 36,
            height: 36,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
          }}
        />
      </IconButton>
      <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 200, p: 0 }}>
        <Box sx={{ p: 2, pb: 1.5 }}>
          <Typography variant="subtitle2" noWrap>
            {userSession.firstname} {userSession.lastname}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {userSession.company_name}
          </Typography>
        </Box>
        <Divider sx={{ borderStyle: 'dashed' }} />
        {!PAYMENT_STRIPE_STATUS.includes(userSession.stripe_billing_status)
          ?
          <Stack sx={{ p: 1 }}>
            {OPTIONS.map((option) => (
              <MenuItem key={option.label} onClick={() => handleClickItem(option.linkTo)}>
                {option.label}
              </MenuItem>
            ))}
          </Stack>
          :
          <Stack sx={{ p: 1 }}>
            <MenuItem onClick={() => handleClickItem(OPTIONS[2].linkTo)}>
              {OPTIONS[2].label}
            </MenuItem>
          </Stack>
        }
        <Divider sx={{ borderStyle: 'dashed' }} />
        <MenuItem
          onClick={handleLogout}
          sx={{ m: 1, fontWeight: 'fontWeightBold', color: 'error.main' }}
        >
          Logout
        </MenuItem>
      </CustomPopover>
    </>
  );
}
